"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkNaniOneClass = exports.checkNaniLinkLogin = exports.getProfile = exports.logoutNaniOneClass = exports.sendData = void 0;

var _jsrsasign = _interopRequireDefault(require("jsrsasign"));

var _common = require("../utils/common");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var ONE_CLUB_API_DOMAIN = "https://api.nani.cool/dev/members";
var getTokenValidUrlForCookie = ONE_CLUB_API_DOMAIN + "/tokenValid";
var urlSigninforthirdparty = ONE_CLUB_API_DOMAIN + "/signinforthirdparty";
var getUserProfileUrl = ONE_CLUB_API_DOMAIN + "/getUserProfile";
var cookieLoginName = _constants.COOKIE_NANI_LOGIN_TOKEN_NAME; //checkNaniOneClass 確認登入狀況
//sendData 輸入帳密用
//logoutNaniOneClass 登出用

var sendData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
    var isAccount, isPass, dataJson;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isAccount = checkAccount(username);
            isPass = checkPass(password);

            if (isAccount.code) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", isAccount);

          case 4:
            if (isPass.code) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", isPass);

          case 6:
            dataJson = JSON.stringify({
              username: username,
              password: password,
              from: "Nani"
            });
            return _context.abrupt("return", fetch(urlSigninforthirdparty, {
              method: "POST",
              // headers 加入 json 格式
              headers: {
                "Content-Type": "application/x-www-form-urlencoded" // 'Authorization': 'Basic ' + AuthorizationCode

              },
              body: dataJson
            }).then(function (response) {
              if (!response.ok) throw new Error(response.statusText);
              return response.json();
            }).then(function (data) {
              //能進來應該已經是對的 response.ok
              if (data) {
                if (data.code === "SUCCESS") {
                  if (data.jwt) {
                    var jws = new _jsrsasign.default.jws.JWS();
                    jws.parseJWS(data.jwt);
                    var hed = jws.parsedJWS.headS;
                    var dte = JSON.parse(hed);

                    if (jws.parsedJWS.payloadS) {
                      var payloads = JSON.parse(jws.parsedJWS.payloadS); //暫時不管控emailvalid
                      //   if (payloads.emailvalid) {

                      //暫時不管控emailvalid
                      //   if (payloads.emailvalid) {
                      saveTokenData(data);
                      return {
                        code: "SUCCESS",
                        jwt: checkNaniLinkLogin()
                      }; //   } else {
                      //     return {
                      //       code: "FAILED",
                      //       message:
                      //         "登入失敗 Email尚未驗證，您的Email為 " + payloads.email
                      //     };
                      //   }
                    } else {
                      return {
                        code: "FAILED",
                        message: "登入失敗 Q_Q 資料異常"
                      };
                    }
                  } else {
                    return {
                      code: "FAILED",
                      message: "登入失敗 Q_Q 登入資料JWT發生異常"
                    };
                  }
                } else {
                  // code: "FAILED"
                  return {
                    code: "FAILED",
                    message: "帳號不存在或密碼錯誤"
                  };
                }
              } else {
                return {
                  code: "FAILED",
                  message: "無資料"
                };
              }
            }).catch(function (err) {
              return {
                code: "FAILED",
                message: "登入失敗 發生異常錯誤"
              };
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.sendData = sendData;

function saveTokenData(token) {
  if (_typeof(token) == "object") {
    setNaniOneClassCookie(cookieLoginName, JSON.stringify(token), token.jwt); // localStorage["signInUserSessionForToken"] = JSON.stringify(token);
  } else if (typeof token == "string") {
    setNaniOneClassCookie(cookieLoginName, token, token); // localStorage["signInUserSessionForToken"] = token;
  }
}

var logoutNaniOneClass = function logoutNaniOneClass() {
  deleteNaniOneClassCookie(cookieLoginName);
};

exports.logoutNaniOneClass = logoutNaniOneClass;

var getProfile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(getUserProfileUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: JSON.stringify(params)
            }).then(function (res) {
              return res.json();
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getProfile(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getProfile = getProfile;

var checkNaniLinkLogin = function checkNaniLinkLogin() {
  var gettoken = getNaniOneClassCookie(cookieLoginName);

  if (gettoken) {
    return gettoken;
  }

  return "";
};

exports.checkNaniLinkLogin = checkNaniLinkLogin;

function getNaniOneClassCookie(name) {
  return (0, _common.getCookie)(name);
}

function setNaniOneClassCookie(cname, cvalue, jwt) {
  (0, _common.setCookieByJwtExpire)(cname, cvalue, jwt);
}

var deleteNaniOneClassCookie = function deleteNaniOneClassCookie(name) {
  (0, _common.deleteCookie)(name);
};

function checkAccount(account) {
  var returnObj = {
    code: true,
    message: ""
  };
  var reAccount = new RegExp(/^[A-Za-z0-9]+$/);

  if (account.replace(/(^\s*)|(\s*$)/g, "").length === 0) {
    returnObj["code"] = "FAILED";
    returnObj["message"] = "請輸入會員帳號";
  }

  return returnObj;
}

function checkPass(password) {
  var returnObj = {
    code: true,
    message: ""
  };
  var re = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{8,12}$/);

  if (password.replace(/(^\s*)|(\s*$)/g, "").length === 0) {
    returnObj["code"] = "FAILED";
    returnObj["message"] = "請輸入密碼";
  }

  return returnObj;
}

var checkNaniOneClass = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(callback) {
    var checkToken, jsonObj;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            checkToken = checkNaniLinkLogin();

            if (checkToken) {
              try {
                jsonObj = JSON.parse(checkToken);

                if (jsonObj.jwt) {
                  checkTokenValidForCookie(jsonObj.jwt, callback);
                } else {
                  callback("");
                }
              } catch (error) {
                callback("");
              }
            } else {
              callback("");
            }

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function checkNaniOneClass(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.checkNaniOneClass = checkNaniOneClass;

function checkTokenValidForCookie(nanitoken, callback) {
  var dataJson = JSON.stringify( // eslint-disable-next-line no-unexpected-multiline
  {
    jwt: nanitoken
  });
  fetch(getTokenValidUrlForCookie, {
    method: "POST",
    // headers 加入 json 格式
    headers: {
      "Content-Type": "application/x-www-form-urlencoded" // 'Authorization': 'Basic ' + AuthorizationCode

    },
    body: dataJson
  }).then(function (response) {
    if (!response.ok) throw new Error(response.statusText);
    return response.json();
  }).then(function (jsonData) {
    var newdate = new Date().getTime();

    if (jsonData.jwt) {
      callback(jsonData.jwt);
    } else {
      logoutNaniOneClass(function myfunction(result) {
        callback("");
      });
    } //能進來應該已經是對的 response.ok

  }).catch(function (err) {
    logoutNaniOneClass(function myfunction(result) {
      callback("");
    });
  });
}